export * from './types.js'
export { default as modalRoot } from './modalRoot.js'
export * from './get-top-level-domain.js'
export * from './cookies-client-side.js'

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const VOID_FN = () => {}
